import { ExternalLink, Instagram, Map, Navigation } from "lucide-react";
import { INSTAGRAM_URL, STRAVA_URL } from "@/lib/noleggio";
import { useI18n } from "@/lib/i18n";

export default function RoutesPage() {
  const { t } = useI18n();
  return (
    <div className="max-w-2xl mx-auto px-5 md:px-8 pt-8 flex flex-col gap-4">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">{t("routes_title")}</h1>
      <div className="mn-card p-8 flex flex-col items-center text-center gap-3 mn-rise">
        <Map size={44} color="var(--brand-primary)" />
        <h2 className="text-xl font-extrabold">{t("routes_heading")}</h2>
        <p className="text-[var(--text-2)] leading-relaxed">{t("routes_text")}</p>
      </div>
      <a data-testid="strava-link-button" href={STRAVA_URL} target="_blank" rel="noopener noreferrer"
        className="min-h-[56px] rounded-2xl bg-[#FC4C02] hover:opacity-90 transition-opacity text-white font-extrabold flex items-center justify-center gap-2.5">
        <Navigation size={22} /> {t("routes_strava")} <ExternalLink size={17} />
      </a>
      <a data-testid="instagram-link-button" href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer"
        className="min-h-[56px] rounded-2xl bg-[#E1306C] hover:opacity-90 transition-opacity text-white font-extrabold flex items-center justify-center gap-2.5">
        <Instagram size={22} /> {t("routes_instagram")} <ExternalLink size={17} />
      </a>
    </div>
  );
}
